export const IS_COMMON = 3
export const IS_ADMIN = 2
export const IS_SUPER_ADMIN = 1

export enum KEY {
  ROLE = 'ROLE'
}
